export const IneInvoiceView: React.FC = () => {
    return <div>IneInvoiceView</div>
}
